import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  ExportFeedbackCommand,
  ExportFeedbackCommandInput,
  GetFeedbackCommand,
  GetFeedbackCommandInput,
  PutFeedbackCommand,
  PutFeedbackCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const feedbackService = {
  get: (data: GetFeedbackCommandInput) => {
    return apiHeliosClient.send(new GetFeedbackCommand(data));
  },
  put: (data: PutFeedbackCommandInput) => {
    return apiHeliosClient.send(new PutFeedbackCommand(data));
  },
  export: (data: ExportFeedbackCommandInput) => {
    return apiHeliosClient.send(new ExportFeedbackCommand(data));
  },
};
